export default "__VITE_ASSET__D0YmoR71__"